import axios from 'axios';
import { requestScheduleItemLoadsQuery } from './queries';
import { buildExpressQuery, buildLoopbackQuery } from './queries/builders';
import Split from '../split';

const requestScheduleItemLoads = async (key, loads) => {
    try {
        const useExpress = Split.getBooleanTreatment('use_express_migration_endpoints');
        const queryBuilder = useExpress ? buildExpressQuery : buildLoopbackQuery;
        const query = requestScheduleItemLoadsQuery({ key, loads, queryBuilder });
        const request = axios.patch(query.url, { ...query.body });
        const { data } = await request;
        return { items: data };
    } catch {
        throw new Error('Unable to edit schedule item');
    }
};

export default requestScheduleItemLoads;
